// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_formBox__esIXv {
  margin-bottom: 1rem;
}

.style_forgetText__cyt1b {
  font-size: 14px;
  line-height: 1rem;
  font-weight: 500;
  margin-top: 0.2rem;
  margin-bottom: 1.5rem;
}

.style_loginBtn__HJsW3 {
  background: #5d87ff;
  color: #fff;
  padding: 1rem;
  width: "100%";
  border: none;
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
}
.style_backToLoginBox__rUWVY {
  margin-top: 0.7rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.style_backToLogin__RZx3Q {
  font-size: 12px;
  color: #5d87ff;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/pages/forgetPassword/styles/style.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".formBox {\n  margin-bottom: 1rem;\n}\n\n.forgetText {\n  font-size: 14px;\n  line-height: 1rem;\n  font-weight: 500;\n  margin-top: 0.2rem;\n  margin-bottom: 1.5rem;\n}\n\n.loginBtn {\n  background: #5d87ff;\n  color: #fff;\n  padding: 1rem;\n  width: \"100%\";\n  border: none;\n  border-radius: 5px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.backToLoginBox {\n  margin-top: 0.7rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.backToLogin {\n  font-size: 12px;\n  color: #5d87ff;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formBox": `style_formBox__esIXv`,
	"forgetText": `style_forgetText__cyt1b`,
	"loginBtn": `style_loginBtn__HJsW3`,
	"backToLoginBox": `style_backToLoginBox__rUWVY`,
	"backToLogin": `style_backToLogin__RZx3Q`
};
export default ___CSS_LOADER_EXPORT___;
